(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Inspiration"] && !Shopify.designMode) return;
  try {
    

(function($) { "use strict";
		
    window.addEventListener("resize", inspirationheight);
    
    function inspirationheight() {
     var content = document.querySelector('.inspirationsection');
     var container = document.querySelector('.case-study-imageslist.show');
     if (!content || !container) return;
     content.style.height = container.offsetHeight + 150 + 'px';  
      
    };

	var pos = 0;
			window.setInterval(function(){
				var el = document.getElementsByClassName('moving-image')[0];
				if (!el) return;
				pos++;
				el.style.backgroundPosition = -pos + "px 0px";
			}, 30
		);
	
	$(document).ready(function() {
		var totalBlocks = $('.case-study-name').length;
		function clearMovingClasses() {
			for (var i = 1; i <= totalBlocks; i++) {
				$('.moving-image').removeClass("mi_" + i);
			}
		}
		$('.case-study-name').each(function(index) {
			var n = index + 1;
			$(this).on('mouseenter', function() {
				$('.case-study-name.active').removeClass('active');
				$('.case-study-images .case-study-imageslist.show').removeClass("show");
				$('.case-study-images .case-study-imageslist:nth-child(' + n + ')').addClass("show");
				$('.case-study-name:nth-child(' + n + ')').addClass('active');
				clearMovingClasses();
				inspirationheight();
				$('.moving-image').addClass("mi_" + n);
			});
		});
		$('.case-study-name:nth-child(1)').trigger('mouseenter');
		clearMovingClasses();
		inspirationheight();
		$('.moving-image').addClass("mi_1");
	});
	




              
	
  })(jQuery);   
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Pure-image-slider"] && !Shopify.designMode) return;
  try {
    

const selectHotspot = (e) => {
  const clickedHotspot = e.target.parentElement;
  const container = clickedHotspot.parentElement;
  
  // only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
  const hotspots = container.querySelectorAll(".lg-hotspot"); 
  hotspots.forEach(hotspot => {
    if (hotspot === clickedHotspot) {
      hotspot.classList.toggle("lg-hotspot--selected");
    } else {
      hotspot.classList.remove("lg-hotspot--selected");
    }
  });
}

(() => {
  const buttons = document.querySelectorAll(".lg-hotspot__button");
  buttons.forEach(button => {
    button.addEventListener("click", selectHotspot);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }
        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine"] && !Shopify.designMode) return;
  try {
    

  // Change these settings

  FlipbookSettings = {
    options: {
      width: 1280,
      height: 980
    },

    shareMessage: 'Decofurn - Catalog',

    table: [
      {text: 'Page 1', page: 1},
      {text: 'Page 2', page: 2},
      {text: 'Page 3', page: 3},
      {text: 'Page 4', page: 4}
    ],

    pageFolder: 'content/catalog/'
  };

  $(window).load(function(event) {
    $("#flipbook .page-1").addClass('animation-on');
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pure-swiper-slider"] && !Shopify.designMode) return;
  try {
    

const selectHotspot = (e) => {
  const clickedHotspot = e.target.parentElement;
  const container = clickedHotspot.parentElement;
  
  // only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
  const hotspots = container.querySelectorAll(".lg-hotspot"); 
  hotspots.forEach(hotspot => {
    if (hotspot === clickedHotspot) {
      hotspot.classList.toggle("lg-hotspot--selected");
    } else {
      hotspot.classList.remove("lg-hotspot--selected");
    }
  });
}

(() => {
  const buttons = document.querySelectorAll(".lg-hotspot__button");
  buttons.forEach(button => {
    button.addEventListener("click", selectHotspot);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slicktabs"] && !Shopify.designMode) return;
  try {
    
const nav = () => {
   const nav = document.querySelector(".pt_js-nav");
   if (!nav) return;
   const navLinks = nav.querySelectorAll(".pt_nav__link");
   const slideRect = nav.querySelector(".pt_nav__slider-rect");

   nav.addEventListener("click", (evt) => {
      if (!evt.target.classList.contains("pt_nav__link")) {
         return;
      }
      evt.preventDefault();

      navLinks.forEach((item) => {
         item.classList.remove("pt_nav__link_active");
      });

      if (!evt.target.classList.contains("pt_nav__link_active")) {
         evt.target.classList.add("pt_nav__link_active");
      }

      slideRect.style.transform = `translateX(${evt.target.dataset.transform}%)`;
   });
};
nav();

  } catch(e) { console.error(e); }
})();
})();
